import { useCallback, useState } from 'react'
import type { CategoryId, DailyResult } from '../game/types'
import { readResult, writeResult } from '../game/persistence'

/**
 * Persists the result of today's puzzle for a category so a refresh restores
 * the finished (or in-progress) state, exactly like Wordle.
 *
 * `refIds` is the puzzle's deterministic starting order of event ids; it lets
 * persistence store/restore the player's arrangement as answer-free position
 * indices rather than ids or dates.
 */
export function useDailyResult(
  day: string,
  category: CategoryId,
  refIds: string[],
) {
  const [result, setResult] = useState<DailyResult | null>(() =>
    readResult(day, category, refIds),
  )

  const save = useCallback(
    (next: DailyResult) => {
      writeResult(next, refIds)
      setResult(next)
    },
    [refIds],
  )

  return { result, save }
}
